import { Navigate } from "react-router-dom";
import { hasMinRole } from "../auth/session";

interface RequireRoleProps {
  minRole: string;
  children: JSX.Element;
}

export function RequireRole({ minRole, children }: RequireRoleProps) {
  if (!hasMinRole(minRole)) {
    return <Navigate to="/" replace />;
  }
  return children;
}
